export default {
  "TopInformation.Title": "お知らせ",
  "TopInformation.InformationSummaryLink": "お知らせ一覧へ",
}
